const { format } = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
})

export const formatCurrencyInt = (num: string | number | null | undefined): string => {
    if (num == null) {
        return ''
    }

    return format(+num)
}
